import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero__container">
        <div className="hero__content">
          <h1 className="hero__title">
            Animation & <span className="hero__accent">—</span>
            <br />
            Compositing, <span className="hero__accent">*</span>
            <br />
            crafted with precision. <span className="hero__accent">...</span>
          </h1>

          <p className="hero__subtitle">
            Commercials, explainers and visual stories
            <br />
            brought to life through motion.
          </p>

          <div className="hero__arrow">↓</div>
        </div>

        <div className="hero__visual">
          <div className="hero__decor hero__decor--circle"></div>
          <div className="hero__decor hero__decor--lines"></div>

          <div className="hero__imageWrap">
           <video
    className="hero__image"
    src="/assets/gif/Header.mp4"
    autoPlay
    loop
    muted
    playsInline
  />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
